module.exports = __webpack_public_path__ + "officialStatic/img/yygd.0d7917b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/yygd.png
// module id = C1sy
// module chunks = 0